const activityWrongAnswerTitles = [
  "Oops! Try again.",
  "Almost there!",
  "Not quite right.",
  "Give it another shot!",
  "Let’s try that one more time.",
];

export default activityWrongAnswerTitles;
